import React from 'react';
import PropTypes from 'prop-types';

import {buttonsV2 as Buttons} from '@breezeway/brzw-components';

import './header_title.scss';

const CLASS_NAME = 'header-title';
const {
  BUTTON_THEMES: { ICON_SUBTLE },
  BUTTON_SIZES: { ICON_MEDIUM },
} = Buttons.constants;

const TitleComponent = ({ onBackClick, title }) => (
  <div className={CLASS_NAME}>
    <Buttons.IconButton
      className={`${CLASS_NAME}__back-button`}
      iconName="high"
      onClick={onBackClick}
      size={ICON_MEDIUM}
      theme={ICON_SUBTLE}
    />
    <div className={`${CLASS_NAME}__divider`} />
    <div className={`${CLASS_NAME}__text`}>{title}</div>
  </div>
);

TitleComponent.propTypes = {
  onBackClick: PropTypes.func,
  title: PropTypes.string,
};

export default TitleComponent;
